import React, { useEffect } from "react";
import { Modal as AntdModal } from "antd";
import useModal from "./useModal";

const Modal = (props) => {
  const { title = "", children, modalRef } = props;

  const { isModalOpen, handleOk, handleCancel, showModal, setIsModalOpen } =
    useModal();

    useEffect(() => {
      modalRef.current = {
        isModalOpen,
        handleOk,
        handleCancel,
        showModal,
        setIsModalOpen,
      };
    }, [isModalOpen, handleOk, handleCancel, showModal, setIsModalOpen]);
    

  return (
    <>
      <AntdModal
      centered
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        {children}
      </AntdModal>
    </>
  );
};

export default Modal;
